import { useCallback, useState } from 'react';

/**
 * Whether any bottom bar is showing. Counted, not a flag: FooterAlert and the
 * subscription banner can both be up, and one leaving must not take away the
 * space the other still needs.
 */
export function useFooterActive() {
  const [count, setCount] = useState(0);

  const setFooterActive = useCallback((active: boolean) => {
    setCount(current => Math.max(0, current + (active ? 1 : -1)));
  }, []);

  return { footerActive: count > 0, setFooterActive };
}
